/* global SideDrawer */
// When the gift-wrapping checkbox is checked or unchecked.
  function checkgift()
  {
  console.log('checkgift');
    if (document.getElementById('gift-wrapping').checked) 
    {
      console.log('gift wrap ticked');
      if (Shopify.Cart)
         Shopify.Cart.GiftWrap.set();
       
    } else {
      console.log('gift wrap not ticked');
      document.getElementById("gift-wrapping").checked = false;
      document.getElementById("giftnoteblock").value = "";
     if(document.getElementById("giftnoteblock")){
       document.getElementById("giftnoteblock").style.display = "none";
     }
      if (Shopify.Cart)
       Shopify.Cart.GiftWrap.remove();     
    }
  }

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
    this.checkProductBlockInSlider();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      this.checkProductBlockInSlider();
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      this.checkProductBlockInSlider();
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }

  checkProductBlockInSlider() {
    const slider = this.querySelector('.slider');

    if (!slider) {
      console.error('Slider not found.');
      return;
    }

    const observer = new MutationObserver((mutationsList, observer) => {
      mutationsList.forEach(mutation => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (node.classList && node.classList.contains('product-block')) {
              // Call your function to append the HTML here
              this.appendHTMLToProductBlock(node);
            }
          });
        }
      });
    });

    // Start observing the slider for changes
    observer.observe(slider, { childList: true, subtree: true });
  }

  appendHTMLToProductBlock(productBlock) {
    const dataTag = productBlock.getAttribute('data-tags');
    const dataPid = productBlock.getAttribute('data-pid');

    if (dataTag) {
      let handles = dataTag.split(',');
      handles.forEach((handle) => {
        handle = handle.trim();

        // Fetch product by handle
        fetch(`/products/${handle}.js`)
          .then(response => {
            if (!response.ok) {
              throw new Error('Product fetch failed for handle: ' + handle);
            }
            return response.json();
          })
          .then(data => {
            const productId = data.id;
            const productHandle = data.handle;

            // Fetch metafield and image
            this.fetchProductMetafieldAndImage(productHandle, productId, productBlock, dataPid);
          })
          .catch(error => {
            console.error('Error fetching product data:', error);
          });
      });
    }
  }

  fetchProductMetafieldAndImage(productHandle, productId, productBlock, dataPid) {
    const myHeaders = new Headers();
    myHeaders.append("X-Shopify-Storefront-Access-Token", "cd957a562783baa33bb0bb44fa04e03b");
    myHeaders.append("Content-Type", "application/json");

    const metquery = `{
      product(handle: "${productHandle}") {
        metafield(namespace: "custom", key: "color_swatch") {
          key
          value
        }
      }
    }`;

    const graphql = JSON.stringify({ query: metquery });
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: graphql
    };

    fetch("https://goondiwindi-cotton.myshopify.com/api/2024-07/graphql.json", requestOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error('GraphQL fetch failed for handle: ' + productHandle);
        }
        return response.json();
      })
      .then(result => {
        if (result?.data?.product?.metafield) {
          const mediaId = result.data.product.metafield.value;

          if (mediaId) {
            // Fetch the media image and append it to the product block
            this.fetchProductMediaImage(mediaId, productHandle, productId, productBlock, dataPid);
          } else {
            console.log("No mediaId found in metafield.");
          }
        } else {
          console.error('Invalid product or metafield not found:', result);
        }
      })
      .catch(error => {
        console.error('Error fetching metafield or GraphQL data:', error);
      });
  }

  fetchProductMediaImage(mediaId, productHandle, productId, productBlock, dataPid) {
  const myHeaders = new Headers();
  myHeaders.append("X-Shopify-Storefront-Access-Token", "cd957a562783baa33bb0bb44fa04e03b");
  myHeaders.append("Content-Type", "application/json");

  const query = `
  {
    node(id: "${mediaId}") {
      ... on MediaImage {
        image {
          url
          altText
          width
          height
        }
      }
    }
  }`;

  fetch('https://goondiwindi-cotton.myshopify.com/api/2024-07/graphql.json', {
    method: 'POST',
    headers: myHeaders,
    body: JSON.stringify({ query })
  })
    .then(response => response.json())
    .then(urldata => {
      if (urldata?.data?.node?.image) {
        const imgURL = urldata.data.node.image.url;

        // Check if the button already exists
        const siblingProductsButton = productBlock.querySelector('.sibling_products_button');
        const colorSwatches = siblingProductsButton?.querySelector('.color-swatches');
        
        if (colorSwatches) {
          const existingButton = colorSwatches.querySelector(`.color-swatch[data-param-handle="${productHandle}"]`);

          // Only append if the button doesn't already exist
          if (!existingButton) {
            const productInfoHtml = `
            <button class="color-swatch" data-param-handle="${productHandle}" data-param-id="${productId}" data-product-id="${dataPid}">
              <img src="${imgURL}" alt="">
            </button>`;
            colorSwatches.innerHTML += productInfoHtml;
          } else {
            console.log(`Button for handle "${productHandle}" already exists.`);
          }
        } else {
          console.error('Color swatches container not found in productBlock.');
        }
      } else {
        console.error('Image data not found in GraphQL response.');
      }
    })
    .catch(error => {
      console.error('Error fetching image:', error);
    });
}
}

window.customElements.define('cart-drawer', CartDrawer);
